import React from 'react';
import LeadDetail_Comp from '../../Components/LeadDetail/LeadDetail';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function LeadDetail() {
  return (
    <>
    <Dashboard_Comp>
    <LeadDetail_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default LeadDetail;